import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { listBranches } from "../../api/directory";
import { useDirtyNavigate } from "../../context/DirtyGuard";
import { EmployeeForm } from "./EmployeeForm";

// لوحة التعديل: تفتح كصفحة مستقلة عبر ?edit=1. لا تعرض معلومات أخرى.
export const EmployeeEditPanel = ({ employee, onSaved }) => {
  const { id } = useParams();
  const requestNav = useDirtyNavigate();
  const [branches, setBranches] = useState([]);

  useEffect(() => {
    listBranches().then(setBranches).catch(() => setBranches([]));
  }, []);

  const exit = () => requestNav(`/employees/${id}`);

  return (
    <div className="w-full" data-testid="detail-edit-panel">
      <EmployeeForm
        initial={employee}
        branches={branches}
        onCancel={exit}
        onSaved={() => {
          onSaved();
          exit();
        }}
      />
    </div>
  );
};
